import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useOptions} from './';

const defaultOptions = {
    allowErrorHighlighting: false,
    filterType: undef,
    googlePlaceApiKey: undef,
    googlePlaceApiUrl: undef,
    hideSelectedFilter: undef,
    highlightMode: undef,
    iconName: 'location',
    id: 'destination',
    matchMode: undef,
    minLength: undef,
    popoverDesktopMaxWidth: undef,
    popoverDesktopMinMarginRight: undef,
    popoverDesktopMinWidth: undef,
    popoverDesktopWidth: undef,
    popoverMaxDisplayCount: undef,
    popoverMaxDisplayCountMobile: undef,
    recentSearchesDisplayMax: undef,
    remotePath: undef,
    retainUserInput: undef,
    showIcon: undef,
    showInlineSuggestion: undef,
    showRecentSearches: undef,
    showResultIcons: undef,
    showResultLabels: undef,
    showSpinner: undef,
    showTrendingSuggestions: undef,
    truncateResultTerms: undef,
    usePopoverAnimation: undef,
    useResultsAnimation: undef
};

function useDestinationOptions(props) {
    const {
        destinationOptions: propsOptions
    } = props;

    const {
        options
    } = useOptions(defaultOptions, propsOptions);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useDestinationOptions};
